import {
  Dumbbell,
  Flag,
  Trophy,
  type LucideIcon,
} from "lucide-react";
import { BaseballIcon } from "@/components/icons/BaseballIcon";
import { PickleballIcon } from "@/components/icons/PickleballIcon";
import { TennisIcon } from "@/components/icons/TennisIcon";

export type Sport =
  | "pickleball"
  | "tennis"
  | "golf"
  | "soccer"
  | "baseball"
  | "weightlifting";

export type SportMeta = {
  id: Sport;
  label: string;
  icon: LucideIcon;
  tagline: string;
};

export const SPORTS: SportMeta[] = [
  {
    id: "pickleball",
    label: "Pickleball",
    icon: PickleballIcon,
    tagline: "Dinks, drops, drives, and kitchen strategy.",
  },
  {
    id: "tennis",
    label: "Tennis",
    icon: TennisIcon,
    tagline: "Strokes, footwork, serve, and doubles play.",
  },
  {
    id: "golf",
    label: "Golf",
    icon: Flag,
    tagline: "Full swing, short game, putting, course play.",
  },
  {
    id: "soccer",
    label: "Soccer",
    icon: Trophy,
    tagline: "First touch, passing, finishing, defending.",
  },
  {
    id: "baseball",
    label: "Baseball",
    icon: BaseballIcon,
    tagline: "Hitting, throwing, fielding, and pitching.",
  },
  {
    id: "weightlifting",
    label: "Weightlifting",
    icon: Dumbbell,
    tagline: "Squat, deadlift, press, and Olympic lifts.",
  },
];

export function getSportMeta(id: Sport): SportMeta {
  return SPORTS.find((s) => s.id === id) ?? SPORTS[0];
}
